import {Component, ElementRef, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute} from '@angular/router';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {UsersModel} from "../../../models/users/users.model";
import {UsersService} from "../../../models/users/users.service";
import {CompaniesService} from "../../../models/companies/companies.service";
import {CompaniesModel} from "../../../models/companies/companies.model";
import {IRoleModel, Roles} from "../../../models/roles";
import {ValidationService} from "../../../services/validation.service";
import { Router } from '@angular/router';
import { ApplicationUser } from './../../../services/ApplicationUser';


@Component({
    selector: 'users',
    templateUrl: 'user-one.template.html'
})
export class UsersOneComponent {

    @ViewChild('confirmDialog') public confirmDialog;

    public userId;

    public user: UsersModel =  new UsersModel();

    public companies: CompaniesModel[] = [];

    public roles: IRoleModel[];
    
    public $userForm;

    public isNew: boolean;

    public disabledEmail = false;
    
    constructor(
        private http: Http, 
        private toasterService: ToasterService, 
        private route: ActivatedRoute,
        protected el: ElementRef,
        protected validationService: ValidationService,
        public usersService: UsersService,
        public companiesService: CompaniesService,
        public rolesModel: Roles,
        private router: Router,
        public admin: ApplicationUser
    ) {
        this.route.params.subscribe(params => {
            this.userId = params['id'];
            this.checkUser();

            if (this.userId != 'create') {
                this.isNew = false;
                this.usersService.getOne(this.userId)
                    .subscribe(
                        (res) => {
                            this.user = res.data;
                        },
                        (error) => {
                            let errorData = JSON.parse(error._body);
                            this.toasterService.pop('error', 'Error', errorData.message);
                        });
            }
            else {
                this.isNew = true;
            }
        });
    }

    ngOnInit(): void {
        this.loadCompanies();
        this.loadRoles();
    }

    checkUser() {
        if (this.userId != 'create' && this.admin.user.id != this.userId) {
            this.disabledEmail = true;
            return false;
        }
        return true;
    }

    loadRoles() {
        this.roles = this.rolesModel.getRoles();
    }

    loadCompanies() {
        this.companiesService.getList()
            .subscribe(
                (res) => {
                    this.companies = res.data;
                },
                (error) => {
                    console.log(error);
                });


    }

    ngAfterViewInit() {
        this.$userForm = $('[name="user-form"]', this.el.nativeElement);
        this.validateForm();
    }

    private validateForm() {
        this.$userForm
            .validate({
                submitHandler: (form) => {
                    this.user.active = +this.user.active;
                    if (this.isNew) {
                        this.usersService.add(this.user)
                            .subscribe(
                                (res) => {
                                    this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                    this.router.navigate(['/users/' + res.data.id]);
                                },
                                (error) => {
                                    this.validationService.showError(error, form);
                                });

                        return false;
                    }
                    else {
                        this.usersService.edit(this.userId, this.user)
                            .subscribe(
                                (res) => {
                                    this.user = res.data;
                                    this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                },
                                (error) => {
                                    this.validationService.showError(error, form);
                                });

                        return false;
                    }
                }
            });
    }

    clearInProgress = false;

    clearAccount() {
        if (this.clearInProgress) return;
        this.confirmDialog.show('Do you want to clear this account?');
    }

    applyClearAccount() {
        if (this.clearInProgress) return;
        this.clearInProgress = true;

        this.usersService.clearAccount(this.userId)
            .subscribe(
                (res) => {
                    this.clearInProgress = false;
                    this.toasterService.pop('success', 'Success', 'Cleared');
                },
                (error) => {
                    this.clearInProgress = false;
                    this.toasterService.pop('error', 'Error', 'Error. Try again');
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/views/users/user-one/user-one.component.ts